import ENV from "../env";

const getOrgCategories = async (orgId) => {
  const response = await fetch(`${ENV.firebaseApiUrl}/organization/${orgId}/categories`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Get organization's categories failed: " + resData.message);
  }

  return resData;
};

export default getOrgCategories;
